// 资源搜索API
import axios from 'axios';
import { getConfig } from '../utils/config';
import * as Fingerprint from '@fingerprintjs/fingerprintjs';

const BASE_URL = getConfig('api.baseUrl');
const ENDPOINTS = getConfig('api.endpoints');

// 缓存设备指纹
let cachedDeviceId = null;

// 获取设备指纹
const getDeviceId = async () => {
  // 如果已经缓存，直接返回
  if (cachedDeviceId) {
    return cachedDeviceId;
  }

  try {
    // 使用 localStorage 持久化存储指纹
    const storedDeviceId = localStorage.getItem('device_id');
    if (storedDeviceId) {
      cachedDeviceId = storedDeviceId;
      return storedDeviceId;
    }

    // 生成新的指纹
    const fp = await Fingerprint.load();
    const result = await fp.get();
    const deviceId = result.visitorId;

    // 存储到 localStorage 和内存缓存
    localStorage.setItem('device_id', deviceId);
    cachedDeviceId = deviceId;

    return deviceId;
  } catch (error) {
    console.error('生成设备指纹失败:', error);
    
    // 备用方案：使用时间戳和随机数
    const fallbackId = `fallback-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    localStorage.setItem('device_id', fallbackId);
    cachedDeviceId = fallbackId;

    return fallbackId;
  }
};

// 获取用户 token（假设从某处获取）
const getUserToken = () => {
  // 这里应该从本地存储或状态管理中获取
  return 'your-user-token';
};

// 创建 axios 实例
const createAxiosInstance = async () => {
  const deviceId = await getDeviceId();
  const instance = axios.create({
    baseURL: BASE_URL,
    headers: {
      'X-Device-ID': deviceId,
      "token": getUserToken()
    }
  });
  return instance;
};

export const searchResources = async (keyword, page = 1, limit = 20, category = null) => {
  try {
    const axiosInstance = await createAxiosInstance();
    
    // 构建查询参数
    const params = {
      keyword,
      page,
      limit,
      ...(category && { category })
    };
    
    // 使用 GET 请求，将参数作为 query string
    const response = await axiosInstance.get(ENDPOINTS.search, { params });

    // 确保返回正确的数据结构
    if (response.data.code === 0) {
      return {
        code: response.data.code,
        data: response.data.data || [],
        total: response.data.total || 0,
        page: response.data.page || page,
        limit: response.data.limit || limit
      };
    } else {
      console.error('搜索请求失败:', response.data);
      return {
        code: response.data.code,
        data: [],
        total: 0,
        page,
        limit
      };
    }
  } catch (error) {
    console.error('搜索请求失败:', error);
    throw error;
  }
};
export const getHotResources = async (limit = 20) => {
  try {
    const axiosInstance = await createAxiosInstance();
    const response = await axiosInstance.post(ENDPOINTS.hotResources, {
      token: getUserToken(),
      limit
    });

    if (response.data.code === 0) {
      return response.data.data || [];
    } else {
      console.error('获取热门资源失败:', response.data);
      return [];
    }
  } catch (error) {
    console.error('获取热门资源失败:', error);
    return [];
  }
};

// 获取系统统计信息
export const getSystemStats = async () => {
  try {
    const axiosInstance = await createAxiosInstance();
    const response = await axiosInstance.post(ENDPOINTS.stats, {
      token: getUserToken()
    });

    if (response.data.code === 0) {
      return response.data;
    } else {
      console.error('获取统计信息失败:', response.data);
      return null;
    }
  } catch (error) {
    console.error('获取统计信息失败:', error);
    return null;
  }
};
